import type { FaireProductEntity } from "../../entity_types/product";

export const p_bh7qrd95d2: FaireProductEntity = {
  token: "p_bh7qrd95d2",
  type: "product",
  name: "Butter Stick Squishy Toy | Slow Rising Stress Relief Squeeze",
  brandToken: "b_b7p4sywpcz",
  brandName: "huemabe (All Import Duties Covered)",
  imageUrl:
    "https://cdn.faire.com/fastly/550bcb70973b7784b67734f5fb9f9e962b734a9e12c1cd02d880a4291e115d68.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa773c0afc1262007095a21e75b780b84dc99e256c24d49d4f04980bf663a0d8.png",
    "https://cdn.faire.com/fastly/4de69fa42769d3a4d5ab7d509352f39cdfed242931abb86e0f46b67e870ce3b0.png",
  ],
  priceDollars: 5.22,
  description:
    "Bring a touch of fun to your desk, shelf, or collection with this Butter Stick Squishy Toy. Designed to look just like a real stick of salted butter, this ultra-soft squishy features a realistic appearance and an incredibly satisfying slow-rising texture.\n\nMade for endless squeezing, squashing, and stress relief, its soft and squishy feel makes it perfect for fidgeting, relaxation, sensory play, or simply displaying as a playful conversation piece. Whether you're a squishy collector or looking for a unique gift, this butter-inspired toy is sure to bring smiles.\n\nFeatures\n- Realistic butter stick design with printed details\n- Ultra-soft and slow-rising squishy texture\n- Satisfying squeeze and rebound effect\n- Great for stress relief and fidgeting\n- Lightweight and easy to carry\n- Fun novelty item for home, office, or school\n- Perfect for collectors and sensory play enthusiasts\n\nProduct Details\nMaterial: PU Foam\nDesign: Salted Butter Stick\nTexture: Super Soft & Slow Rising\nColor: Butter Yellow\n\nPerfect For\n- Stress relief\n- Desk toys\n- Fidget toys\n- Sensory play\n- Squishy collections\n- Novelty gifts\n- Party favors\n- Home and office decoration\n\nWhy You'll Love It\n- Looks surprisingly realistic\n- Extra slow-rising for maximum satisfaction\n- Fun and relaxing to squeeze repeatedly\n- Great conversation starter\n- Unique gift for squishy lovers and collectors",
  tags: [],
  msrpDollars: 10.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:48.729Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
